define('annotations',[
  "globals",
  "backbone",
  "models/annotations",
  "collections/annotations",
  "views/annotations/annotations",
  "./content"
], function (globals, Backbone, AnnotationModel, AnnotationList, AnnotationsView) {
  "use strict";

  if (globals.options.ui.annotationsEnabled) {
    $(function () {
      var collection = new AnnotationList(globals.content.get("annotations"), {
        model: AnnotationModel
      });

      collection.baseUrl = $("#annotations").data("annotation-base");

      new AnnotationsView({
        name: "annotations",
        el: "#annotations",
        collection: collection
      });
    });
  }
});

